import {
  HomeIcon,
  QueueListIcon,
  CpuChipIcon,
  RectangleStackIcon,
  DocumentTextIcon,
  EnvelopeIcon,
  ShoppingCartIcon,
  ServerIcon,
  WrenchScrewdriverIcon,
  CubeIcon,
  BeakerIcon,
  TagIcon,
  PuzzlePieceIcon,
  Cog6ToothIcon,
  AdjustmentsHorizontalIcon,
  TruckIcon,
  ArchiveBoxIcon,
  UserGroupIcon,
  SwatchIcon,
  CircleStackIcon,
  ShieldCheckIcon,
  StopIcon,
} from '@heroicons/react/24/outline';

const navigation = [
  { name: 'Dashboard', href: '/', icon: HomeIcon },
  {
    name: 'Print Queue',
    icon: QueueListIcon,
    children: [
      { name: 'Print Queue', href: '/print-queue' },
      { name: 'Slicer Jobs', href: '/slicer-jobs' },
    ],
  },
  {
    name: 'Quotes',
    icon: DocumentTextIcon,
    children: [
      { name: 'Slicer Quotes', href: '/slicer-quotes' },
      { name: 'Quotes', href: '/quotes' },
      { name: 'Contacts', href: '/contacts' },
    ],
  },
  { name: 'Orders', href: '/orders', icon: ShoppingCartIcon },
  {
    name: 'Fleet',
    icon: ServerIcon,
    children: [
      { name: 'Machines', href: '/fleet/machines' },
      { name: 'Machine Models', href: '/fleet/machine-models' },
    ],
  },
  {
    name: 'Stock',
    icon: CubeIcon,
    children: [
      { name: 'Filaments', href: '/filaments', icon: BeakerIcon },
      { name: 'Filament Brands', href: '/brands', icon: TagIcon },
      { name: 'Materials', href: '/materials', icon: SwatchIcon },
      { name: 'Material Extras', href: '/material-extras', icon: PuzzlePieceIcon },
    ],
  },
  {
    name: 'Settings',
    icon: Cog6ToothIcon,
    children: [
      { name: 'Farm Settings', href: '/farm-settings', icon: AdjustmentsHorizontalIcon },
      {
        name: 'Slicer Settings',
        icon: WrenchScrewdriverIcon,
        children: [
          { name: 'Presets', href: '/slicer-settings/presets' },
          { name: 'Filament Settings', href: '/slicer-settings/filaments' },
          { name: 'Quality Settings', href: '/slicer-settings/quality' },
        ],
      },
      {
        name: 'Shipping',
        icon: TruckIcon,
        children: [
          { name: 'Shipping Methods', href: '/shipping-methods' },
          { name: 'Boxes', href: '/boxes' },
        ],
      },
      { name: 'Users', href: '/users', icon: UserGroupIcon },
      { name: 'Kill Switch', href: '/kill-switch', icon: StopIcon },
    ],
  },
  {
    name: 'Admin System Data',
    icon: ShieldCheckIcon,
    adminOnly: true,
    children: [
      { name: 'Machine Models', href: '/admin/machine-models' },
      { name: 'Slicer Presets', href: '/admin/slicer-presets' },
      { name: 'Filaments', href: '/admin/filaments' },
      { name: 'Filament Brands', href: '/admin/brands' },
      { name: 'Materials', href: '/admin/materials' },
      { name: 'Material Extras', href: '/admin/material-extras' },
      { name: 'VAT Settings', href: '/admin/vat-settings' },
      { name: 'Kill Switch', href: '/admin/kill-switch', icon: StopIcon },
    ],
  },
];

export default navigation;
